import { useEffect } from 'react';

/**
 * Custom hook that refreshes data when the page becomes visible.
 * Uses the Page Visibility API to detect when the tab/window regains focus.
 * 
 * @param {Function} refreshCallback - Function to call when page becomes visible
 * @param {boolean} enabled - Whether the refresh should be enabled (default: true)
 */
export function useRefreshOnVisible(refreshCallback, enabled = true) {
  useEffect(() => {
    if (!enabled || !refreshCallback) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // Defer the refresh to avoid blocking the visibility change handler
        // This prevents performance warnings from React's internal scheduling
        setTimeout(() => {
          refreshCallback();
        }, 0);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refreshCallback, enabled]);
}

